import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ngx-inline-loader',
  templateUrl: './ngx-inline-loader.component.html',
  styleUrls: ['./ngx-inline-loader.component.scss']
})
export class NgxInlineLoaderComponent implements OnInit {

  @Input() label: string = 'Loading...';

  constructor() { }

  ngOnInit(): void {
  }

}
